// extracted by mini-css-extract-plugin
export var column_title = "features-table-module--column_title--r7FdR";
export var container = "features-table-module--container--54fnf";
export var numeric_feature = "features-table-module--numeric_feature--2a3ZG";
export var row_title = "features-table-module--row_title--Bx+06";
export var table_title = "features-table-module--table_title--gagot";